import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AudioService } from '@app/audio/audio.service';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { ShopService } from '@app/shared/services/shop.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-premium-pass',
  templateUrl: './premium-pass.component.html',
  styleUrls: ['./premium-pass.component.scss'],
  standalone: true,
  imports: [ButtonComponent, AnimatedTimerComponent, SharedModule],
})
export class PremiumPassModalComponent implements OnInit {
  event: LimitedTimeEvent;
  buttonText: string;

  private readonly eventManager = inject(EventManager);
  private readonly audioService = inject(AudioService);
  private readonly translateService = inject(TranslateService);
  private readonly shopService = inject(ShopService);
  private readonly eventsRepo = inject(EventsRepository);
  protected readonly premiumPassModalData = inject<Modal>(MAT_DIALOG_DATA);

  ngOnInit() {
    const eventId = this.premiumPassModalData.data.eventId
      ? this.premiumPassModalData.data.eventId
      : this.premiumPassModalData.data.properties.eventId;

    this.event = this.eventsRepo.getEventById(eventId);
    this.setButtonText();
  }

  openOffer(): void {
    this.audioService.playButtonAudio('functionality');
    this.closeModal();
    this.shopService.openOfferOrShop(this.event?.properties?.activeskus[0]);
  }

  openInfo(): void {
    this.eventManager.openModal(
      new Modal(NonPersistedModalName.PremiumPassInfoModalComponent, ModalType.View, this.event)
    );
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.premiumPassModalData.id, ModalType.View, this.event));
  }

  private setButtonText(): void {
    const propertiesButtonText = this.event.statusCultureButtonText[this.translateService.currentLang];

    this.buttonText = propertiesButtonText
      ? propertiesButtonText
      : this.translateService.instant('home.buttons.go-promo');
  }
}
